import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const GraduationCap01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="graduation-cap-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.74 9.36364L11.8767 4.08169L3.01346 9.36364L11.8767 14.6456L20.74 9.36364ZM22.4845 8.0751C23.4607 8.65682 23.4607 10.0705 22.4845 10.6522L19.8157 12.2427L19.8157 18.1901C19.8157 18.8976 19.4418 19.5525 18.8326 19.9123L13.4406 23.0962C12.4691 23.6699 11.258 23.65 10.3059 23.0448L5.35784 19.8995C4.78045 19.5325 4.43074 18.8958 4.43074 18.2117L4.43074 12.5365L1.26887 10.6522C0.292732 10.0705 0.292726 8.65682 1.26887 8.0751L10.8529 2.36363C11.4837 1.98771 12.2698 1.98771 12.9006 2.36363L22.4845 8.0751ZM6.43074 13.7283L6.43074 18.2117L11.3788 21.3569C11.6961 21.5587 12.0998 21.5653 12.4237 21.3741L17.8157 18.1901V13.4346L12.9006 16.3636C12.2698 16.7396 11.4837 16.7396 10.8529 16.3636L6.43074 13.7283Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
